import styled from 'styled-components'

type CaseBannerContainerProps = {
  color: string
  backgroundColor?: string
}
export const CaseBannerContainer = styled.div<CaseBannerContainerProps>`
  display: flex;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : ''};
  width: 100%;
  max-width: 1170px;

  .banner-img {
    object-fit: cover;
  }

  .banner-info {
    display: flex;
    gap: 110px;
    padding: 0 10px;
    margin: 8px 0;
    background-color: ${(props) => props.color};
    align-items: center;
    justify-content: center;
    width: 100%;

    .title {
      text-align: center;
      max-width: 400px;
    }

    .topics {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    @media (max-width: 700px) {
      flex-direction: column;
      align-items: flex-start;
      margin: 0 0 8px 0;
      padding: 42px 0;
      gap: 34px;

      .topics {
        gap: 16px;
      }
    }
  }

  @media (max-width: 700px) {
    flex-direction: column;

    .banner-img {
      width: 100%;
    }
  }
`
